export enum IExpeditionStatus {
  Empty = '',
  Open = 'Open',
  Ready = 'Ready',
  Ongoing = 'Ongoing',
  Closed = 'Closed',
  Deleted = 'Deleted',
  Cancelled = 'Cancelled'
}
